import {useStore} from '@/store/root-store';
import {observer} from 'mobx-react';
import styled from 'styled-components';
import {useState, useEffect, useRef} from 'react';
import {Card, Col, Row} from 'antd';
import {SkeletonRingLoader} from '@/components/common-components';
import {CurrentPageStore} from '@/store/content-optimizer/currentPage';
import {ImageComponent} from './imageComponent';

interface Props {
  historyCopyStatus?: any;
  onChange: (editorState: any) => any;
  store: CurrentPageStore;
  buttonTitle: any;
  setShowSelectedHistoryImage: any;
  setShowHistoryImage: any;
}

export const ImageListComponent = observer(({onChange, store, historyCopyStatus, buttonTitle, setShowSelectedHistoryImage, setShowHistoryImage}: Props) => {
  const {
    contentOptimizer: {
      aiOutline: {
        dummyImages,
        templatesHistory,
      },
    },
  } = useStore('');
  const ref = useRef(null);
  const [imagesAddedCount, setImagesAddedCount] = useState(20);
  const [imagesDummy, setImagesDummy] = useState([]);
  const [imagesList, setImagesList] = useState([]);

  useEffect(() => {
    const initialImagesLoad = templatesHistory?.slice(0, imagesAddedCount).map(item => {
      return {...item, loading: true};
    }) || [];
    setImagesList(initialImagesLoad);
  }, [templatesHistory?.length]);

  useEffect(() => {
    setImagesDummy(dummyImages);
  }, [dummyImages?.length]);

  return <>
    <Row ref={ref} gutter={[16, 24]} style={{overflow: 'auto', maxHeight: 'calc(100vh - 325px)'}}>
      <>
        {imagesDummy && imagesDummy?.map((val, index)=>(
          <Col className='gutter-row' span={8} key={index}>
            <CardStyle >
              {buttonTitle == 'generate-btn' && val.load && <><SkeletonRingLoader /><p style={{marginTop: '-21px', textAlign: 'center', marginBottom: '0px', fontSize: '12px'}}>Generating 4 images</p></>}
            </CardStyle>
            <div style={{marginTop: '6px'}}>{val.title}</div>
          </Col>
        ))
        }
        {imagesList?.map((item, idx) => <ImageComponent
          imagesAddedCount={imagesAddedCount}
          setImagesAddedCount={setImagesAddedCount}
          key={'ImageComponent-'+idx}
          data={item}
          idx={idx}
          setImagesList={setImagesList}
          onChange={onChange}
          store={store}
          historyCopyStatus={historyCopyStatus}
          setShowSelectedHistoryImage={setShowSelectedHistoryImage}
          setShowHistoryImage={setShowHistoryImage}
          rootElement={ref}
        />)}
      </>
    </Row></>;
});


const CardStyle = styled(Card)`
  background-color: #E0E0E0;
  border-radius: 8px;
  padding: 0px !important;
`;

